import overlay from "./loader";
import updateCartIconQuantity from "./update-cart-icon";
import $ from "jquery";
import updateMiniCart from "./update-mini-cart";
import Modal from "./modal/modal";

$(document).on('click', '.add-offer-to-cart', event => {
    event.preventDefault();

    let cartButton = $(event.target);

    overlay(true);
    window.axios.post(window.config.urls.addOfferToCart.replace(':offer:', $(event.currentTarget).data('offer-id'))).then(({data: data}) => {
        if (data.success) {
            let modal = $('#addToCartModal');

            cartButton.addClass('d-none');

            if (data.message) {
                modal.find('#addToCartMessage').html(data.message);
            }
            modal.find('#addToCartModalContent').html(data.content);
            modal.modal('show');

            updateMiniCart().then(updateCartIconQuantity);
        } else if (data.message) {
            new Modal({
                title: window.config.language.errorOccurred,
                content: Modal.createErrorMessage(data.message),
                buttons: Modal.buttons.alert,
            }).show();
        }
    }).finally(() => {
        overlay(false);
    });
})

$(document).on('click', '.cancel-offer-btn', event => {
    event.preventDefault();

    let url = event.currentTarget.dataset.cancelUrl;
    let modal = $('#cancel-offer');
    let form = modal.find('>form:first');

    form.attr('action', url);

    modal.modal('show');
})
